import React from 'react';

import { Customer } from './models/customer';
import { UserConfig } from './models/user-config';

export interface AppContextValue {
  customerDetails: Customer | null;
  config: UserConfig | null;
  reloadCustomerDetails: (onResult: (customer: Customer | null) => void) => void;
  reloadConfig: (onResult: (config: UserConfig | null) => void) => void;
}

export const AppContext = React.createContext<AppContextValue>({
  customerDetails: null,
  config: null,
  reloadCustomerDetails: () => undefined,
  reloadConfig: () => undefined,
});
